import {
  normalForm,
  WindowState,
} from '@lmt/unicorn-shared/app/components/global-forms/GlobalForms.types';
import { PopupWindow } from '@lmt/unicorn-shared/app/components/global-forms/popup/PopupWindow';
import {
  VersionsList,
  VersionsListProps,
} from '@lmt/unicorn-shared/app/components/patients/profile/cases/components/documents/VersionsList';
import { QuerySuspenseErrorWrapper } from '@lmt/unicorn-shared/app/helpers/retry-helper';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import styles from './DocumentVersionPopup.module.scss';

type DocumentVersionPopupProps = {
  isOpen: boolean;
  onClose: () => void;
} & VersionsListProps;

export const DocumentVersionPopup: React.FC<DocumentVersionPopupProps> = (
  props,
) => {
  const { isOpen, onClose, ...versionsListProps } = props;

  const i18n = useTranslation();

  const [isHidden, setIsHidden] = useState<boolean>(false);

  return isOpen ? (
    <div className={styles.popupContainerLayout}>
      <PopupWindow
        id={0}
        title={i18n.t('global_forms.version_history')}
        tryClose={onClose}
        changeState={() => {}}
        state={'normal'}
        isHidden={isHidden}
        setIsHidden={(id, newIsHidden) => setIsHidden(newIsHidden)}
        isBeingCompleted={false}
        stateSettings={normalForm}
        isFocused={false}
        isLoading={false}
        isCloseButtonHidden={false}
        loadingTitle={''}
      >
        <QuerySuspenseErrorWrapper>
          <VersionsList {...versionsListProps} />
        </QuerySuspenseErrorWrapper>
      </PopupWindow>
    </div>
  ) : null;
};
